import type { BuilderMode } from './types';

/** En modo edición no hay restricción: la encuesta ya existe y su estado guardado es válido
 *  para todos los pasos. En modo creación solo se desbloquean las pestañas ya alcanzadas
 *  (validadas al menos una vez vía "Siguiente"), para no permitir saltar a un paso sin datos. */
export function canJumpToStep(mode: BuilderMode, targetIndex: number, maxStepReached: number): boolean {
  return mode === 'edit' || targetIndex <= maxStepReached;
}
